import { GlobalContext } from '../context/GlobalState';
import { useContext, useState } from 'react';
import { createOrUpdateCard } from '../utils/createOrUpdateCard';
import { MdClose, MdDone } from 'react-icons/md';
import { API_BASE_URL } from '../utils/apiBaseUrl';

export const ApplyWindow = ({ card, setOpenApplyWindow, setIsApplied }) => {
  const { userId, userEmail, showNotification } = useContext(GlobalContext);
  const { cardType, cardId, userApplied } = card;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [applyMessage, setApplyMessage] = useState('');
  const [city, setCity] = useState('');
  const [role, setRole] = useState('');
  const [availability, setAvailability] = useState('');
  const [portfolioUrl, setPortfolioUrl] = useState('');
  const [messageToCardOwner, setMessageToCardOwner] = useState('');

  const url =
    cardType === 'musician'
      ? `${API_BASE_URL}/musicians/${cardId}`
      : `${API_BASE_URL}/bands/${cardId}`;

  const buildApplicationMessage = () => {
    const lines = [
      'Hello! I am interested in collaborating with you.',
      `Role: ${role.trim()}`,
      `City: ${city.trim()}`,
      `Availability: ${availability}`,
    ];

    if (portfolioUrl.trim()) {
      lines.push(`Portfolio: ${portfolioUrl.trim()}`);
    }

    if (messageToCardOwner.trim()) {
      lines.push('');
      lines.push(`Message: ${messageToCardOwner.trim()}`);
    }

    return lines.join('\n');
  };

  const handleApproveClick = async () => {
    if (!city.trim() || !role.trim() || !availability) {
      setApplyMessage('Please fill City, Role, and Availability.');
      showNotification('Please complete required fields.', 'warning');
      return;
    }

    setIsSubmitting(true);
    setApplyMessage('');

    const finalMessage = buildApplicationMessage();

    const response = await createOrUpdateCard(
      url,
      {
        userApplied: [
          ...userApplied,
          {
            userId,
            userEmail,
            city: city.trim(),
            role: role.trim(),
            availability,
            portfolioUrl: portfolioUrl.trim(),
            message: finalMessage,
          },
        ],
      },
      'PATCH',
    );

    if (response?.ok) {
      setIsApplied(true);
      showNotification('Application sent successfully.', 'success');
      return;
    }

    setApplyMessage('Could not send your application. Please try again.');
    showNotification('Could not send your application.', 'error');
    setIsSubmitting(false);
  };
  return (
    <div className='apply-window'>
      <div className='apply-window-header'>
        <p className='apply-window-title'>Before you send</p>
        <p className='apply-window-subtitle'>
          Keep it short, friendly, and clear.
        </p>
      </div>

      <ul className='apply-info-list'>
        <li>
          <span className='apply-info-point'>Email</span>
          <span>Your account email is shared with the card owner.</span>
        </li>
        <li>
          <span className='apply-info-point'>Message</span>
          <span>Your note appears in the owner notifications panel.</span>
        </li>
        <li>
          <span className='apply-info-point'>Tip</span>
          <span>Use complete details to improve response quality.</span>
        </li>
      </ul>

      <div className='apply-grid'>
        <div className='apply-field'>
          <label htmlFor='apply-city'>City *</label>
          <input
            id='apply-city'
            name='apply-city'
            type='text'
            placeholder='e.g. Istanbul'
            value={city}
            onChange={e => {
              setCity(e.target.value);
            }}
          />
        </div>

        <div className='apply-field'>
          <label htmlFor='apply-role'>Role *</label>
          <input
            id='apply-role'
            name='apply-role'
            type='text'
            placeholder='e.g. Guitarist / Vocalist'
            value={role}
            onChange={e => {
              setRole(e.target.value);
            }}
          />
        </div>

        <div className='apply-field'>
          <label htmlFor='apply-availability'>Availability *</label>
          <select
            id='apply-availability'
            name='apply-availability'
            value={availability}
            onChange={e => {
              setAvailability(e.target.value);
            }}
          >
            <option value=''>Select availability</option>
            <option value='Weekdays evenings'>Weekdays evenings</option>
            <option value='Weekends'>Weekends</option>
            <option value='Flexible'>Flexible</option>
            <option value='Project-based only'>Project-based only</option>
          </select>
        </div>

        <div className='apply-field'>
          <label htmlFor='apply-portfolio'>
            Portfolio / Demo Link (optional)
          </label>
          <input
            id='apply-portfolio'
            name='apply-portfolio'
            type='url'
            placeholder='https://...'
            value={portfolioUrl}
            onChange={e => {
              setPortfolioUrl(e.target.value);
            }}
          />
        </div>
      </div>

      <label htmlFor='message'>Additional message (optional)</label>
      <textarea
        id='message'
        name='message'
        value={messageToCardOwner}
        maxLength={600}
        placeholder='Tell them about your style, experience, and goals.'
        onChange={e => {
          setMessageToCardOwner(e.target.value);
        }}
      />
      <div className='apply-counter'>{messageToCardOwner.length}/600</div>
      {applyMessage && <div className='message-error'>{applyMessage}</div>}
      <button
        type='button'
        className='action-button action-save'
        disabled={isSubmitting}
        onClick={() => {
          handleApproveClick();
        }}
      >
        <MdDone />
        <span>{isSubmitting ? 'Sending...' : 'Send application'}</span>
      </button>
      <button
        type='button'
        className='action-button'
        disabled={isSubmitting}
        onClick={() => {
          setOpenApplyWindow(false);
        }}
      >
        <MdClose />
        <span>Cancel</span>
      </button>
    </div>
  );
};
